var _clipPath;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemImageClipPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 620 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "svgClip",
    clipPathUnits: "objectBoundingBox",
    transform: "scale(0.0016129032 0.0033333333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 1.81198e-05C0 1.81198e-05 20 2.19345e-05 0 1.14441e-05V300H240C251.046 300 260 291.046 260 280V260C260 248.954 268.954 240 280 240H340C351.046 240 360 248.954 360 260V280C360 291.046 368.954 300 380 300H620V1.43051e-05C600 1.43051e-05 620 1.81198e-05 600 1.81198e-05H20Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemImageClipPath);
export default __webpack_public_path__ + "static/media/item-image-clip-path.54b1fa11c9ef071c957dd17011a6acf7.svg";
export { ForwardRef as ReactComponent };